// SelectionModal.tsx
import React from "react";
import { Modal } from "antd";
import SelectionPopup, { ItemType, SelectionType } from "./SelectionPopup";

interface SelectionModalProps {
  isModalOpen: boolean;
  handleCancel: () => void;
  onApplySelection: (type: "project" | "study", values: string[]) => void;
  projects: any;
  clinicalStudy: any;
  selectedItemsProp: ItemType[];
  selectionTypeProp: SelectionType | null;
}

const SelectionModal: React.FC<SelectionModalProps> = ({ isModalOpen, handleCancel, onApplySelection, projects, clinicalStudy, selectedItemsProp, selectionTypeProp }) => {
  return (
    <Modal
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
      centered
      width={800}
      style={{ height: "80vh" }} // sets the outer container height
      bodyStyle={{
        height: "calc(90vh - 110px)", // subtracts header/footer height
        overflowY: "auto",
      }}
    >
      <SelectionPopup onSelect={onApplySelection} projects={projects} clinicalStudy={clinicalStudy} selectedItemsProp={selectedItemsProp} selectionTypeProp={selectionTypeProp}/>
    </Modal>
  );
};

export default SelectionModal; 